import { inject, Injectable } from '@angular/core'
import { ArchivesService } from '@app/generated/api/archives/archives.service'
import type { ArchivesSuppliersListParams } from '@app/generated/api/model'

@Injectable({
  providedIn: 'root',
})
export class SuppliersApi {
  private readonly archivesService = inject(ArchivesService)

  list (params: ArchivesSuppliersListParams) {
    return this.archivesService.suppliers(params)
  }
}
